import { FormItem } from '@magicdoorinc/form';
import { useLocalization, LabeledTextInput } from '@magicdoorinc/ui';
import { LabeledBankingAccountType } from '~/components/common/Inputs/form-inputs/LabeledBankingInput';
import { BankAccountType } from '~/swagger/pay/Api';
import { bankAccountNumber, bankAccountRoutingNumber, bankAccountType } from '~/utils/formRules';
import type { LabeledGroupProps } from '@magicdoorinc/ui';
import type { Component } from 'solid-js';

interface LabeledBankingInputForPayabliProps extends LabeledGroupProps {
  onClick?: (isMouseDown: boolean) => void;
  fieldName?: string;
}

/**
 * Form fields for Pay mode ACH payment method creation.
 * Fields: holderName, accountNumber, routingNumber, accountType.
 * Does NOT include bankName (not required by CreateAchPaymentMethodRequestDto).
 */
const LabeledBankingInputForPayabli: Component<LabeledBankingInputForPayabliProps> = (props) => {
  const { t } = useLocalization();

  return (
    <div class="flex flex-col gap-5">
      <FormItem
        label={t('Account holder name')}
        placeholder={t('Enter account holder name')}
        onClick={props.onClick}
        formFieldName={props.fieldName ? [props.fieldName, 'holderName'] : 'holderName'}
        component={LabeledTextInput}
        rules={[
          { required: true, message: t('Please enter account holder name') },
          {
            length: [1, 200],
            message: t('{name} must be between {min} and {max} characters', {
              name: t('Account holder name'),
              min: '1',
              max: '200',
            }),
          },
        ]}
      />
      <FormItem
        label={t('Account number')}
        onClick={props.onClick}
        placeholder={t('Enter account number')}
        formFieldName={props.fieldName ? [props.fieldName, 'accountNumber'] : 'accountNumber'}
        component={LabeledTextInput}
        rules={bankAccountNumber(t)}
      />
      <FormItem
        label={t('Routing number')}
        onClick={props.onClick}
        placeholder={t('Enter routing number')}
        formFieldName={props.fieldName ? [props.fieldName, 'routingNumber'] : 'routingNumber'}
        component={LabeledTextInput}
        rules={bankAccountRoutingNumber(t)}
      />
      <FormItem
        onClick={props.onClick}
        formFieldName={props.fieldName ? [props.fieldName, 'accountType'] : 'accountType'}
        component={LabeledBankingAccountType}
        options={Object.entries(BankAccountType).map(([key, value]) => ({ label: t(key), value }))}
        rules={bankAccountType(t)}
        label={t('Account type')}
      />
    </div>
  );
};

export default LabeledBankingInputForPayabli;
